import React from 'react';

interface Round {
  round: number;
  winner: string;
  reason: string;
}

interface RoundsVisualTimelineProps {
  roundsTimeline: Round[];
}

export const getRoundIcon = (reason: string) => {
  const baseUrl = "/images/vetos/";

  switch (reason) {
    case "Bomb Exploded":
      return (
        <img
          src={`${baseUrl}bomb_exploded.svg`}
          alt="Bomb Exploded"
          className="round-icon-svg"
        />
      );
    case "Bomb Defused":
      return (
        <img
          src={`${baseUrl}bomb_defused.svg`}
          alt="Bomb Defused"
          className="round-icon-svg"
        />
      );
    case "T Win":
      return (
        <img
          src={`${baseUrl}t_win.svg`}
          alt="T Win"
          className="round-icon-svg"
        />
      );
    case "CT Win":
      return (
        <img
          src={`${baseUrl}ct_win.svg`}
          alt="CT Win"
          className="round-icon-svg"
        />
      );
    case "Round Draw":
    case "RoundDraw":
      // Round draw is a CT win (time runs out)
      return (
        <img
          src={`${baseUrl}stopwatch.svg`}
          alt="Round Draw"
          className="round-icon-svg"
          title="Round Draw - Time ran out (CT Win)"
        />
      );
    default:
      return (
        <img
          src={`${baseUrl}ct_win.svg`}
          alt="Elimination"
          className="round-icon-svg"
        />
      );
  }
};

const RoundsVisualTimeline: React.FC<RoundsVisualTimelineProps> = ({ roundsTimeline }) => {
  return (
    <div className="rounds-visual-section">
      <h3 className="rounds-title">Round History</h3>

      {/* Visual Timeline - Two Row Layout */}
      <div className="rounds-visual-timeline">
        <div className="timeline-container">
          {/* Team 1 Row */}
          <div className="team-row">
            <div className="rounds-container">
              {Array.from({ length: 24 }, (_, index) => {
                const roundNumber = index + 1;
                const actualRound = roundsTimeline.find(
                  (r) => r.round === roundNumber
                );
                const isTeam1Round = actualRound && actualRound.winner === "team1";

                return (
                  <div key={roundNumber} className="round-cell">
                    {isTeam1Round && (
                      <>
                        <div className="round-number">
                          {roundNumber}
                        </div>
                        <div
                          className="round-icon"
                          title={`Round ${roundNumber}: ${actualRound.reason}`}
                        >
                          {getRoundIcon(actualRound.reason)}
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Team 2 Row */}
          <div className="team-row">
            <div className="rounds-container">
              {Array.from({ length: 24 }, (_, index) => {
                const roundNumber = index + 1;
                const actualRound = roundsTimeline.find(
                  (r) => r.round === roundNumber
                );
                const isTeam2Round = actualRound && actualRound.winner === "team2";

                return (
                  <div key={roundNumber} className="round-cell">
                    {isTeam2Round && (
                      <>
                        <div className="round-number">
                          {roundNumber}
                        </div>
                        <div
                          className="round-icon"
                          title={`Round ${roundNumber}: ${actualRound.reason}`}
                        >
                          {getRoundIcon(actualRound.reason)}
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoundsVisualTimeline;